import Http from '../http'

export default {

  index() {
    return Http.get(`/negotiations`)
  },

  indexWithFilter(filter) {
    return Http.get(`/negotiations`, {params: { ...filter }})
  },


  create(negotiation){
    return Http.post(`/negotiations`, {negotiation: {
      ...negotiation,
    }})
  },

  update(negotiation){
    return Http.put(`/negotiations/${negotiation.id}`, {
      negotiation: {
        ...negotiation,
      },
    });
  },

  show(id) {
    return Http.get(`/negotiations/${id}`);
  },

  delete(id){
    return Http.delete(`/negotiations/${id}`)
  }

}